import React from "react";
import moment from "moment";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";
import addDays from "date-fns/addDays";
import DateRangeCalendar from "./DateRangeCalendar";

const DEFAULT_RANGES = [
  { label: "This month", getValue: () => [startOfMonth(new Date()), new Date()] },
  { label: "Last month", getValue: () => [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))] },
  { label: "Last 2 months", getValue: () => [startOfMonth(addMonths(new Date(), -2)), endOfMonth(addMonths(new Date(), -1))] },
  { label: "Last 3 months", getValue: () => [startOfMonth(addMonths(new Date(), -3)), endOfMonth(addMonths(new Date(), -1))] },
  { label: "Last 7 days", getValue: () => [addDays(new Date(), -7), new Date()] },
  { label: "Last 14 days", getValue: () => [addDays(new Date(), -14), new Date()] },
  { label: "Last 30 days", getValue: () => [addDays(new Date(), -30), new Date()] },
];

const AppDateRangePicker = ({ value, onChange }) => {
  const [start, end] = value || [null, null];

  const presets = DEFAULT_RANGES.map((preset) => {
    const [presetStart, presetEnd] = preset.getValue();
    const isActive =
      !!start && !!end && moment(start).isSame(presetStart, "day") && moment(end).isSame(presetEnd, "day");
    return {
      label: preset.label,
      isActive,
      onSelect: () => onChange([presetStart, presetEnd]),
    };
  });

  return (
    <DateRangeCalendar
      startDate={start}
      endDate={end}
      onApply={(from, to) => onChange([from, to])}
      presets={presets}
    />
  );
};

export default AppDateRangePicker;
